import { useSegmentAnalytics } from '.'

import { useUserQuery } from '~generated/hooks'
import { AUTH_DATA_KEYS, BILLING_EVENTS, CLICK_EVENTS, CREATE_EVENTS } from '~lib/constants'
import useCookie from '~lib/hooks/useCookie'
import sendSlackMessage from '~lib/slack/sendSlackMessage'

export type AnalyticsType = CLICK_EVENTS | CREATE_EVENTS | BILLING_EVENTS

// TODO - refactor all of the analytics logic
const useAnalytics = () => {
  const { sendClickOrCreateSegmentData } = useSegmentAnalytics()

  const cookie = useCookie()
  const userId = cookie[AUTH_DATA_KEYS.USER_ID]

  const { data } = useUserQuery({
    variables: {
      id: userId,
    },
  })

  const { email } = data?.user || {}

  const sendAnalyticsEvent = (eventType: AnalyticsType, data?: Record<string, string>) => {
    const type = eventType?.toLowerCase().includes('click') ? 'click' : 'create'

    // Get module info in case user clicked on a launch module
    const { moduleViewed } = data || {}

    if (eventType && email) {
      sendClickOrCreateSegmentData(eventType, {
        ...data,
      })
      sendSlackMessage({
        type,
        email,
        moduleViewed,
        event: eventType,
      })
    }
  }

  return {
    sendAnalyticsEvent,
  }
}

export default useAnalytics
